<div class="py-px-16 px-px-32">
  <div class="d-flex justify-content-between">
    <div class="fs-20 fw-7">{{ isEdit ? 'Modifier un collaborateur' : 'Inviter un collaborateur' }}</div>
    <div>
      <svg-icon src="assets/icons/close.svg" class="cursor-pointer" (click)="dialogRef.close()"></svg-icon>
    </div>
  </div>

  <div class="fs-13 text-neutral-dark-grey mt-px-8" *ngIf="!isEdit">
    Le collaborateur recevra un e-mail pour activer son compte et choisir son mot de passe (lien valable 96 h).
  </div>

  <div [formGroup]="form" autocomplete="off">
    <app-custom-input
      [parentForm]="form" controlName="mail"
      [errorMessage]="(form.get('mail')?.touched && form.get('mail')?.errors?.['email']) ? 'Veuillez entrer un email valide.' : ''"
      label="Email (identifiant de connexion)" [required]="true" innerClass="mt-px-16"></app-custom-input>
    <div class="fs-11 text-neutral-dark-grey" *ngIf="emailLocked">
      L'e-mail d'un compte activé ne peut plus être modifié (il sert à la connexion et au code de vérification).
    </div>

    <div class="form-grid identity-row mt-px-16">
      <div class="field">
        <mat-label>Civilité</mat-label>
        <div class="dropdown position-relative">
          <mat-select formControlName="title" placeholder="—">
            @for (item of civilityOptions; track item) {
              <mat-option [value]="item.value">{{ item.label }}</mat-option>
            }
          </mat-select>
        </div>
      </div>
      <div class="field">
        <app-custom-input label="Prénom" [parentForm]="form" controlName="firstName" [required]="true"></app-custom-input>
      </div>
      <div class="field">
        <app-custom-input label="Nom" [parentForm]="form" controlName="lastName" [required]="true"></app-custom-input>
      </div>
    </div>

    <div class="form-grid role-row mt-px-16">
      <div class="field">
        <mat-label>Rôle <span class="required">*</span></mat-label>
        <div class="dropdown position-relative">
          <mat-select formControlName="role">
            @for (role of roles; track role.value) {
              <mat-option [value]="role.value">{{ role.label }}</mat-option>
            }
          </mat-select>
        </div>
        <div class="fs-11 text-neutral-dark-grey mt-px-4">{{ selectedRoleDescription }}</div>
        <div class="fs-11 text-neutral-dark-grey" *ngIf="roleLocked">Le dirigeant principal reste administrateur.</div>
        <div class="fs-11 text-neutral-dark-grey" *ngIf="isSelf && !roleLocked">Vous ne pouvez pas modifier votre propre rôle.</div>
      </div>
      <div class="field">
        <app-custom-input [label]="isAutre ? 'Nom du poste' : 'Fonction'" [parentForm]="form" controlName="fonction"
                          [required]="isAutre"
                          [placeholder]="isAutre ? 'ex : Comptable' : 'ex : Chargé(e) de recrutement'"></app-custom-input>
        <div class="fs-11 text-neutral-dark-grey mt-px-4" *ngIf="isAutre">
          Le nom du poste s'affiche à côté du rôle « Autre » dans la liste des collaborateurs.
        </div>
      </div>
    </div>

    <!-- Lot G (G4) : toggles on/off par utilisateur — s'appliquent à CE compte seul (Q6). -->
    <div class="permissions-block mt-px-16" *ngIf="permissionsLoaded">
      <mat-label>Droits du compte</mat-label>
      <div class="fs-11 text-neutral-dark-grey mb-px-8" *ngIf="permissionsEditable">
        Les défauts du rôle sont pré-activés ; activez (vert) ou désactivez (gris) chaque droit pour ce collaborateur,
        sans impact sur les autres comptes.
      </div>
      <div class="fs-11 text-neutral-dark-grey mb-px-8" *ngIf="!permissionsEditable && roleLocked">
        Le compte administrateur du service a tous les droits et n'est pas configurable.
      </div>
      <div class="fs-11 text-neutral-dark-grey mb-px-8" *ngIf="isSelf && !roleLocked">
        Vous ne pouvez pas modifier vos propres droits.
      </div>
      <div class="fs-11 text-neutral-dark-grey mb-px-8" *ngIf="!permissionsEditable && !roleLocked && !isSelf">
        Les droits de ce compte suivent son rôle. Seuls l'administrateur (ou un compte autorisé à « modifier les droits »)
        peut les ajuster.
      </div>
      <div class="permissions-list">
        @for (key of matrixKeys; track key) {
          <label class="permission-row" [class.disabled]="!canToggle(key)">
            <span class="permission-left">
              <button type="button" class="info-btn" title="Voir ce que ce droit permet"
                      [attr.aria-label]="'Détail du droit : ' + permissionLabels[key]"
                      (click)="openPermissionInfo(key, $event)">i</button>
              <span class="permission-label">{{ permissionLabels[key] }}</span>
            </span>
            <span class="switch">
              <input type="checkbox" [checked]="permissionState[key]" [disabled]="!canToggle(key)"
                     (change)="togglePermission(key)" />
              <span class="slider"></span>
            </span>
          </label>
        }
        @if (permissionsEditable || isAdmin) {
          @for (key of extraKeys; track key) {
            <label class="permission-row" [class.disabled]="!canToggle(key)">
              <span class="permission-left">
                <button type="button" class="info-btn" title="Voir ce que ce droit permet"
                        [attr.aria-label]="'Détail du droit : ' + permissionLabels[key]"
                        (click)="openPermissionInfo(key, $event)">i</button>
                <span class="permission-label">{{ permissionLabels[key] }}</span>
              </span>
              <span class="switch">
                <input type="checkbox" [checked]="permissionState[key]" [disabled]="!canToggle(key)"
                       (change)="togglePermission(key)" />
                <span class="slider"></span>
              </span>
            </label>
          }
        }
      </div>
    </div>
    <div class="photo-phone-row mt-px-16">
      <app-custom-dragdrop-image text1=""
                                 [url]="images"
                                 innerClass="rounded border border-1 p-4 me-2"
                                 [singleImage]="true" text2="" width="146" height="146"
                                 [smallInput]="true" text3="Ajouter une photo de profil"
                                 icon="/assets/icons/camera.svg"
                                 (sendImage)="getImage($event)"
                                 [isDeletble]="true">
      </app-custom-dragdrop-image>
      <div class="field phone-field">
        <mat-label>Téléphone</mat-label>
        <ngx-intl-tel-input
          [cssClass]="'custom'"
          [preferredCountries]="[CountryISO.France]"
          [enableAutoCountrySelect]="false"
          [enablePlaceholder]="true"
          [searchCountryFlag]="true"
          [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
          [selectFirstCountry]="false"
          [selectedCountryISO]="CountryISO.France"
          [maxLength]="phoneMaxLength"
          [phoneValidation]="true"
          [inputId]="'agency-user-phone'"
          formControlName="numTel"
          (ngModelChange)="onInputChange($event)"
        ></ngx-intl-tel-input>
        <div *ngIf="form.get('numTel')?.touched && form.get('numTel')?.invalid" class="required">
          Veuillez saisir un numéro valide.
        </div>
      </div>
    </div>
  </div>

  <div class="required fs-13 mt-px-16" *ngIf="errorMessage">{{ errorMessage }}</div>

  <mat-dialog-actions align="end" class="mt-px-24">
    <app-button (handleClick)="dialogRef.close()" [stroked]="true" text="Annuler"></app-button>
    <app-button (handleClick)="submit()"
                [loading]="loading"
                [disabled]="form.invalid || loading"
                innerClass="ml-px-8"
                [text]="isEdit ? 'Enregistrer' : 'Envoyer l\'invitation'"></app-button>
  </mat-dialog-actions>
</div>
